import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBillingPriceListComponent } from './customer-billing-price-list/customer-billing-price-list.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { CustomerBillingPriceService } from './customer-billing-price.service';
import { CustomerBillingPriceEditComponent } from './customer-billing-price-edit/customer-billing-price-edit.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { CustomerBillingComponentsModule } from '@fi-app/customer-billing/customer-billing-components/customer-billing-components.module';
import { CustomerBillingPriceListStateComponent } from './customer-billing-price-list/customer-billing-price-list-state.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        MatRadioModule,
        CustomerBillingComponentsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        SelectSearchModule,
        FiToggleSwitchModule,
    ],
    declarations: [
        CustomerBillingPriceListComponent,
        CustomerBillingPriceEditComponent,
        CustomerBillingPriceListStateComponent,
    ],
    providers: [CustomerBillingPriceService],
})
export class CustomerBillingPriceModule {}
